import microuniversoApi from "../../api/microuniversoApi";
import {IOrcamento} from "../../types/IOrcamento";

export async function salvarOrcamento(orcamento: IOrcamento) {
    return await microuniversoApi.Orcamento.salvar(orcamento)
}
